<template>
  <div id="app">
    <!--<keep-alive :include="cachePage">-->
      <router-view></router-view>
    <!--</keep-alive>-->
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapState('app', {
      cachePage: state => state.cachePage
    }),
    cachePage () {
      return this.$store.state.app.cachePage
    }
  }
}
</script>
<style lang="scss">
#app{
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue